import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import getWeekDays from './utils';
import styles from './DaysFilter.module.scss';


const DaysFilter = React.forwardRef(({ tintColor, onDaySelect, date, week, t }, ref) => {
    const weekDays = getWeekDays(date);
    const { neededDate, daysFilterApplied } = useSelector(({ groups }) => groups);
    const [todaySelected, setTodaySelected] = React.useState(false);
    const [width, setWidth] = React.useState(0);
    useEffect(() => {
        const index = weekDays.findIndex((day) => day.format('Y M D') === neededDate);

        if (index > -1 && daysFilterApplied && !todaySelected) {
            onDaySelect(weekDays[index].format('Y M D'));
            setTodaySelected(true);
        }
        // eslint-disable-next-line
    }, [neededDate]);

    useEffect(() => {
        if (width === 0) {
            setWidth(ref?.current?.clientWidth);
        }

        const handleResize = () => {
            setWidth(ref?.current?.clientWidth);
        }
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [ref, width]);

    useEffect(() => {
        setTodaySelected(false);
    } ,[week]);

    const handleDaysFilter = (day) => () => {
        onDaySelect(day.format('Y M D'));
    };

    const activeDayWrapperStyles = {
        borderColor: tintColor,
        backgroundColor: tintColor,
    };
    const activeDayStyles = {
        color: '#ffffff',
    };

    const getDay = (day) => {
        let displayDay;

        if (width >= 760) {
            displayDay = t(`homeScreen.groupClasses.${day.locale('en').format('dddd').toLowerCase()}`);
        } else if (width < 760 && width >= 650) {
            displayDay = t(`homeScreen.groupClasses.${day.locale('en').format('dddd').toLowerCase()}`).slice(0, 4);
        } else if (width < 649 && width >= 500) {
            displayDay = t(`homeScreen.groupClasses.${day.locale('en').format('dddd').toLowerCase()}`).slice(0, 2);
        } else if (width <= 499) {
            displayDay = t(`homeScreen.groupClasses.${day.locale('en').format('dddd').toLowerCase()}`)[0];
        }

        return displayDay;
    };

    return (
        <div className={styles.daysFilterWrapper} ref={ref}>
            {weekDays?.map((day, index) => (
                <div
                    key={index}
                    className={styles.dayWrapper}
                    style={neededDate === day.format('Y M D') ? activeDayWrapperStyles : {}}
                    onClick={handleDaysFilter(day)}
                    data-testid={`data-test-daysfilter-day-${day.locale('en').format('yyyy-MM-DD')}`}
                >
                    <div
                        className={styles.day}
                        style={neededDate === day.format('Y M D') ? activeDayStyles : {}}
                    >
                        {getDay(day)}
                    </div>
                </div>
            ))}
        </div>
    )
});

export default DaysFilter;
